import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import { Modal, Button, Form } from "react-bootstrap";
import swal from "sweetalert";
import DataTable from "react-data-table-component";
import { customStyles } from "../../assets/table-style";
import "@fortawesome/fontawesome-free/css/all.min.css";
import BASE_URL from "../../assets/global/url";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { ThreeDot } from "react-loading-indicators";
import NoAccess from "../../assets/img/NoAccess.png";
import useDecodeToken from "../../hooks/customHook/useDecodeToken";
// import DatePicker from "react-datepicker";
import { PaginationControls } from "../../hooks/customHook/paginationHook/usePagination";
import { useServerPagination } from "../../hooks/customHook/paginationHook/useServerPagination";
import { ArrowsClockwise } from "@phosphor-icons/react";
import CustomDatePicker from "../../components/CustomDatePicker";
import FilterStore from "../../hooks/customHook/FilterStore";
import { NoTranslate } from "../../helper/prevent_translate_browser";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import VendorCsv from "./Sub Folder/VendorCsv";
import VendorPdf from "./Sub Folder/VendorPdf";
import countryOptions from "../../assets/global/Countries";
import useDarkMode from "../../components/Themes/Usedarkmode";
import { useServerSort } from "../../hooks/customHook/sortingHook/useTableSort";

const Vendors = ({ authrztn }) => {
  const { themeSelectStyles } = useDarkMode();
  const navigate = useNavigate();
  const userLoggedID = useDecodeToken();
  // const yearRef = useRef();

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  // fetch
  const [vatPercent, setVatPercent] = useState(0);
  const [vatEnabled, setVatEnabled] = useState(false);
  const [companyName, setcompanyName] = useState("");
  const [companyNature, setcompanyNature] = useState("");
  const [emailAddress, setemailAddress] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [designation, setDesignation] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [mname, setMname] = useState("");
  const [civilStatus, setCivilStatus] = useState("");
  const [dob, setDob] = useState(yesterday);
  const [gender, setGender] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [contactNo2, setContactNo2] = useState("");
  const [tin, setTin] = useState("");
  const [position, setPosition] = useState("");
  // const [selectedID, setSelectedID] = useState("");
  ///PARA ITO SA FILTER RETENTION
  //START
  const [filterStatus, setFilterStatus] = useState(() =>
    FilterStore.getBusinessStatus(),
  );
  // save on change for filter retention
  useEffect(() => {
    FilterStore.saveBusinessStatus(filterStatus);
  }, [filterStatus]);
  const [filterDesignation, setFilterDesignation] = useState(() =>
    FilterStore.getDesignation(),
  );
  // save on change for filter retention
  useEffect(() => {
    FilterStore.saveDesignation(filterDesignation);
  }, [filterDesignation]);
  ///
  const [searchText, setSearchText] = useState(() =>
    FilterStore.VgetSearch(`vendors`),
  );
  useEffect(() => {
    FilterStore.VsaveSearch(searchText, `vendors`);
  }, [searchText]);
  //END
  const [isLoading, setIsLoading] = useState(true);
  // const [deletionTrigger, setDeletionTrigger] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState([]);
  const [showChangeStatusModal, setShowChangeStatusModal] = useState(false);
  const [changeToStatus, setChangeToStatus] = useState("");
  const [tagAllProduct, setTagAllProduct] = useState(false);
  const [supplierCode, setSupplierCode] = useState("");

  // validation
  const [validated, setValidated] = useState(false);

  // clear filter

  const [filterColumn, setFilterColumn] = useState("all");

  // Export PDF/CSV
  const [exportData, setExportData] = useState([]);
  const csvLinkRef = useRef();
  const [showPdfPreview, setShowPdfPreview] = useState(false);
  const [pendingCsvDownload, setPendingCsvDownload] = useState(false);

  // total supplier count
  const [totalSuppliers, setTotalSuppliers] = useState(0);

  // new supplier (this month) count
  const [monthlySupplierCount, setMonthlySupplierCount] = useState(0);

  // update show modal
  // const [showUpdateModal, setShowUpdateModal] = useState(false);

  // add show modal
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => {
    setShowModal(true);
  };
  const [currency, setCurrency] = useState([]);
  const [currencyID, setCurrencyID] = useState("");
  const reloadCurrency = () => {
    axios.get(BASE_URL + "/currency/fetchCurrency").then((res) => {
      setCurrency(res.data);
    });
  };

  // const [selectYear, setSelectYear] = useState(false);
  // const [yearList, setYearList] = useState([]);

  // function range(start, end, step = 1) {
  //   const result = [];
  //   for (let i = start; i < end; i += step) {
  //     result.push(i);
  //   }
  //   return result;
  // }

  // const years = range(1900, new Date().getFullYear() + 1, 1);
  // const months = [
  //   "January",
  //   "February",
  //   "March",
  //   "April",
  //   "May",
  //   "June",
  //   "July",
  //   "August",
  //   "September",
  //   "October",
  //   "November",
  //   "December",
  // ];

  // const generateYears = (year) => {
  //   setYearList(() => {
  //     const updated = [];
  //     const currentYear = new Date().getFullYear();

  //     // Generate years based on current year or selected year
  //     const yearList = Array.from(
  //       { length: 16 },
  //       (_, i) => (year ? year : currentYear) - 16 + i + 1
  //     );

  //     // Divide array by 4 items
  //     for (let i = 0; i < yearList.length; i += 4) {
  //       updated.push(yearList.slice(i, i + 4));
  //     }

  //     return updated;
  //   });
  // };

  // const increaseYear = (changeYear) => {
  //   setYearList((prev) => {
  //     const updated = prev.map((item) => item.map((year) => year + 10));
  //     changeYear(updated[3][3]);

  //     return updated;
  //   });
  // };

  // const decreaseYear = (changeYear) => {
  //   setYearList((prev) => {
  //     const updated = prev.map((item) => item.map((year) => year - 10));
  //     changeYear(updated[3][3]);

  //     return updated;
  //   });
  // };

  const handleDateChange = (date) => {
    // const newContactPersons = [...contactPersons];
    // newContactPersons[index].dob = e.target.value;
    // setContactPersons(newContactPersons);

    if (!date) {
      setDob(yesterday);
      return;
    }

    const today = new Date();

    const isToday =
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate();

    if (isToday) {
      swal({
        icon: "warning",
        title: "Invalid Birth Date",
        text: "Birth date cannot be today's date. Please select a valid past date.",
      });

      return;
    }

    setDob(date);
  };

  // const handleResetToToday = (changeYear, changeMonth) => {
  //   const currentYear = new Date().getFullYear();

  //   setDob(new Date());

  //   generateYears(); // Reset Year List

  //   changeYear(currentYear); // Set year

  //   changeMonth(
  //     months.indexOf(
  //       months[new Date().getMonth()] // Set month
  //     )
  //   );
  // };

  const handleClose = () => {
    setVatPercent(0);
    setVatEnabled(false);
    setShowModal(false);
    // setShowUpdateModal(false);
    setcompanyName("");
    setcompanyNature("");
    setemailAddress("");
    setCompanyAddress("");
    setCity("");
    setCountry("");
    setDesignation("");
    setFname("");
    setLname("");
    setMname("");
    setCivilStatus("");
    setDob(yesterday);
    setGender("");
    setContactNo("");
    setContactNo2("");
    setTin("");
    setPosition("");
    setSupplierCode("");
    setValidated(false);

    // Reset contactPersons to its initial state
    setContactPersons([
      {
        fname: "",
        lname: "",
        mname: "",
        civilStatus: "",
        dob: "",
        gender: "",
        contactNo: "",
        tin: "",
      },
    ]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    // Validate form fields
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      swal({
        icon: "error",
        title: "Fields are required",
        text: "Please fill in the red text fields.",
        buttons: false,
        timer: 2000,
      });
      setValidated(true);
      return;
    }

    swal({
      title: "Create this new supplier?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (confirmed) => {
      if (confirmed) {
        try {
          const res = await axios.post(BASE_URL + "/vendors/addVendors", {
            tagAllProduct,
            companyName: companyName.trim(),
            companyNature,
            emailAddress,
            companyAddress,
            city,
            country,
            designation,
            fname,
            mname,
            lname,
            civilStatus,
            dob,
            gender,
            contactNo,
            contactNo2,
            tin,
            position,
            currencyID,
            supplierCode,
            userLoggedID,
            vatPercent,
          });

          if (res.status === 200) {
            swal({
              title: "Success!",
              text: "Suppliers successfully added.",
              icon: "success",
              buttons: false,
              timer: 2000,
            });
            handleClose();
            reloadTable();
            supplierCount();
            fetchMonthlySupplierCount();
          } else if (res.status === 201) {
            swal({
              title: "Already Exist!",
              text: "Suppliers duplicated, unable to insert.",
              icon: "warning",
              buttons: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.error("Error adding Suppliers:", error);
          swal({
            title: "Error!",
            text: "There was an error adding the Suppliers.",
            icon: "error",
            buttons: false,
            timer: 2000,
          });
        }
      }
    });
  };

  // update
  // const handleUpdateShow = (data) => {
  //   setShowUpdateModal(true);
  //   setSelectedID(data.id);
  //   setcompanyName(data.company_name);
  //   setcompanyNature(data.company_nature);
  //   setemailAddress(data.company_email);
  //   setCompanyAddress(data.company_address);
  //   setCity(data.company_city);
  //   setCountry(data.company_country);
  //   setDesignation(data.company_designation);
  //   setFname(data.fname);
  //   setLname(data.fname);
  //   setMname(data.lname);
  //   setCivilStatus(data.civil_status);
  //   setDob(data.dob);
  //   setGender(data.gender);
  //   setContactNo(data.contact);
  //   setTin(data.tin_number);
  //   setPosition(data.position);
  // };

  // const handleUpdate = async (e) => {
  //   e.preventDefault();
  //   const form = e.currentTarget;
  //   if (form.checkValidity() === false) {
  //     e.preventDefault();
  //     e.stopPropagation();
  //     swal({
  //       icon: "error",
  //       title: "Fields are required",
  //       text: "Please fill in the red text fields.",
  //       buttons: false,
  //       timer: 2000,
  //     });
  //   } else {
  //     swal({
  //       title: "Update this suppliers?",
  //       text: "",
  //       icon: "warning",
  //       buttons: true,
  //       dangerMode: true,
  //     }).then((confirmed) => {
  //       if (confirmed) {
  //         try {
  //           axios
  //             .post(BASE_URL + "/vendors/updateVendors", {
  //               companyName,
  //               companyNature,
  //               emailAddress,
  //               companyAddress,
  //               city,
  //               country,
  //               designation,
  //               fname,
  //               mname,
  //               lname,
  //               civilStatus,
  //               dob,
  //               gender,
  //               contactNo,
  //               tin,
  //               position,
  //               selectedID,
  //             })
  //             .then((res) => {
  //               if (res.status === 200) {
  //                 swal({
  //                   title: "Success!",
  //                   text: "Vendors successfully updated.",
  //                   icon: "success",
  //                   buttons: false,
  //                   timer: 2000,
  //                 });

  //                 handleClose();
  //                 reloadTable();
  //               } else if (res.status === 201) {
  //                 swal({
  //                   title: "Already Exist!",
  //                   text: "Vendors duplicated, unable to update.",
  //                   icon: "warning",
  //                   buttons: false,
  //                   timer: 2000,
  //                 });
  //               }
  //             });
  //         } catch (error) {
  //           console.error("Error updating Vendors:", error);
  //           swal({
  //             title: "Error!",
  //             text: "There was an error updating the vendors.",
  //             icon: "error",
  //             buttons: false,
  //             timer: 2000,
  //           });
  //         }
  //       }
  //     });
  //   }
  //   setValidated(true);
  // };

  const handleDeleteVendor = async (id) => {
    try {
      swal({
        icon: "warning",
        title: "Confirm Deletion",
        text: "Are you sure you want to delete?",
        buttons: ["Cancel", "OK"],
        dangerMode: true,
      })
        .then(async (confirmed) => {
          if (confirmed) {
            const res = await axios.put(
              `${BASE_URL}/vendors/deleteVendor/${id}`,
            );

            if (res.status === 200) {
              swal({
                icon: "success",
                title: "Supplier Successfully Deleted",
                text: "The Supplier has been successfully deleted",
              }).then(() => {
                reloadTable();
                supplierCount();
                fetchMonthlySupplierCount();
                // setDeletionTrigger(true);
              });
            }
          }
        })
        .catch((error) => {
          console.error(error);

          if (error.response && error.response.status === 409) {
            const wrapper = document.createElement("div");
            wrapper.innerHTML = `
              <span style="color: rgba(0, 0, 0, 0.65)">
                Delete first the purchase order in module <strong>Create Purchase</strong> with Transaction
                Number: <strong>${error.response.data.transaction_id}</strong>
              </span>
            `;
            swal({
              icon: "error",
              title: "Deletion Prohibited",
              content: wrapper,
            });
            return;
          }

          swal({
            title: "Something went wrong",
            text: "Please contact your support immediately",
            icon: "error",
            timer: 2000,
          });
        });
    } catch (error) {
      console.error(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
        timer: 2000,
      });
    }
  };

  const handleChangeStatus = () => {
    try {
      if (changeToStatus === "") {
        swal({
          icon: "warning",
          title: "Warning",
          text: "Please select status before proceeding.",
        });
        return;
      }

      swal({
        icon: "warning",
        title: "Are you sure?",
        text: "You are about to change the status of selected items.",
      })
        .then(async (confirm) => {
          if (confirm) {
            const res = await axios.put(
              `${BASE_URL}/vendors/vendorChangeStatus`,
              {
                selectedVendor: [...new Set(selectedVendor)],
                changeToStatus,
              },
            );

            if (res.status === 200) {
              swal({
                icon: "success",
                title: "Statuses Updated",
                text: "All selected items have been updated",
              }).then(() => {
                setSelectedVendor([]);
                setChangeToStatus("");
                setShowChangeStatusModal(false);
                reloadTable();
              });
            }
          }
        })
        .catch((error) => {
          console.error(error);
          swal({
            title: "Something went wrong",
            text: "Please contact your support immediately",
            icon: "error",
            timer: 2000,
          });
        });
    } catch (error) {
      console.error(error);
    }
  };

  // country options come from the static list imported at the top (Countries.js)

  // add another contact person
  const [contactPersons, setContactPersons] = useState([
    {
      fname: "",
      lname: "",
      mname: "",
      civilStatus: "",
      dob: "",
      gender: "",
      contactNo: "",
      contactNo2a: "",
      tin: "",
    },
  ]);

  // const addContactPerson = () => {
  //   setContactPersons([
  //     ...contactPersons,
  //     {
  //       fname: "",
  //       lname: "",
  //       mname: "",
  //       civilStatus: "",
  //       dob: "",
  //       gender: "",
  //       contactNo: "",
  //       tin: "",
  //     },
  //   ]);
  // };

  // const removeContactPerson = (index) => {
  //   const newContactPersons = contactPersons.filter((_, i) => i !== index);
  //   setContactPersons(newContactPersons);
  // };

  // Fetch data
  // const [showData, setShowData] = useState([]);

  // Trigger CSV download only after VendorCsv has re-rendered with new data
  useEffect(() => {
    if (pendingCsvDownload && exportData.length > 0) {
      csvLinkRef.current.link.click();
      setPendingCsvDownload(false);
    }
  }, [exportData, pendingCsvDownload]);

  // Export PDF
  const exportToPdf = async () => {
    swal({
      icon: "warning",
      title: "Export to PDF?",
      text: "Do you want to export this data as a PDF file?",
      dangerMode: true,
      buttons: true,
    }).then(async (confirm) => {
      if (confirm) {
        const res = await axios.get(
          `${BASE_URL}/vendors/getVendorsData-search`,
          {
            params: {
              filterStatus,
              filterDesignation,
              filterColumn,
              searchText: searchText || "",
              limit: 100000,
              page: 1,
            },
          },
        );
        setExportData(res.data.data || []);
        setShowPdfPreview(true);
      }
    });
  };

  // Export CSV
  const exportToCsv = async () => {
    swal({
      icon: "warning",
      title: "Export to CSV?",
      text: "Do you want to export this data as a CSV file?",
      dangerMode: true,
      buttons: true,
    }).then(async (confirm) => {
      if (confirm) {
        const res = await axios.get(
          `${BASE_URL}/vendors/getVendorsData-search`,
          {
            params: {
              filterStatus,
              filterDesignation,
              filterColumn,
              searchText: searchText || "",
              limit: 100000,
              page: 1,
            },
          },
        );
        setExportData(res.data.data || []);
        setPendingCsvDownload(true);
      }
    });
  };

  const pagination = useServerPagination(
    "about:blank",
    FilterStore.VgetPerPage("vendors"),
  );

  // No initial sortBy: the backend default (newest first) has no visible column,
  // so every header starts neutral until the user picks one
  const sort = useServerSort(pagination);

  // Guards against saving the automatic reset-to-1 that updateApiUrl/updateParams
  // triggers on mount — we only want to save pages the user actually navigated to.
  const pageRestored = useRef(false);

  // Save page to FilterStore whenever it changes
  useEffect(() => {
    if (!pageRestored.current) return; // still in mount cycle, skip
    if (pagination.currentPage) {
      FilterStore.VsavePage(pagination.currentPage, "vendors");
    }
  }, [pagination.currentPage]);

  // Save perPage to FilterStore whenever it changes
  // NOTE: hook exposes `itemsPerPage` + `changeItemsPerPage`, not `rowsPerPage`
  useEffect(() => {
    if (pagination.itemsPerPage) {
      FilterStore.VsavePerPage(pagination.itemsPerPage, "vendors");
    }
  }, [pagination.itemsPerPage]);
  // fetch
  const reloadTable = () => {
    ///PARA ITO SA FILTER RETENTION
    //START
    //NEW APPROACH OF CONDITION
    const hasFilter = filterStatus !== "Active" || filterDesignation !== "All";

    pagination.updateApiUrl(
      hasFilter
        ? BASE_URL + "/vendors/getVendorsData-filter"
        : BASE_URL + "/vendors/getVendorsData",
    );
    //END
    pagination.updateParams({
      filterStatus,
      filterDesignation,
      filterColumn,
      searchText,
    });
    setIsLoading(false);
    // axios
    //   .get(BASE_URL + "/vendors/filterSearchVendors", {
    //     params: {
    //       filterStatus,
    //       filterDesignation,
    //       filterColumn,
    //       searchText,
    //     },
    //   })
    //   .then((res) => {
    //     setShowData(res.data);
    //     setIsLoading(false);
    //   });
  };

  // supplier count
  const supplierCount = () => {
    axios
      .get(BASE_URL + "/vendors/countVendors")
      .then((response) => {
        setTotalSuppliers(response.data.totalVendors);
      })
      .catch((error) => {
        console.error("Error fetching supplier count:", error);
      });
  };

  // supplier month count
  const fetchMonthlySupplierCount = async () => {
    try {
      const response = await axios.get(
        BASE_URL + "/vendors/countVendorsWithinMonth",
      );
      setMonthlySupplierCount(response.data.count);
    } catch (error) {
      console.error("Error fetching monthly supplier count:", error);
    }
  };

  useEffect(() => {
    supplierCount();
    fetchMonthlySupplierCount();
  }, []);

  useEffect(() => {
    reloadCurrency();
    reloadTable();

    // updateApiUrl() and updateParams() inside reloadTable both call
    // setCurrentPage(1) internally — defer restore so it runs after those settle,
    // then open the save gate so user navigation is persisted from here on.
    const savedPage = FilterStore.VgetPage("vendors");
    if (savedPage > 1) {
      setTimeout(() => {
        pagination.setCurrentPage(savedPage);
        pageRestored.current = true; // saves are now live
      }, 0);
    } else {
      setTimeout(() => {
        pageRestored.current = true; // no restore needed, but open saves
      }, 0);
    }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFilterStatusChange = (e) => {
    const value = e.target.value;
    setFilterStatus(value);
    pagination.updateApiUrl(BASE_URL + "/vendors/getVendorsData-filter");
    pagination.updateParams({
      filterStatus: value,
      filterDesignation,
    });
  };

  const handleFilterDesignationChange = (e) => {
    const value = e.target.value;
    setFilterDesignation(value);
    pagination.updateApiUrl(BASE_URL + "/vendors/getVendorsData-filter");
    pagination.updateParams({
      filterStatus,
      filterDesignation: value,
    });
  };
  const debounceTimer = useRef(null);
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);

    // Clear previous debounce timer
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    // Set new debounce timer
    debounceTimer.current = setTimeout(async () => {
      pagination.updateApiUrl(BASE_URL + "/vendors/getVendorsData-search");
      pagination.updateParams({
        filterStatus,
        filterDesignation,
        filterColumn,
        searchText: value,
      });
    }, 600);

    // Cleanup timer on unmount or searchTermFilter change
    return () => clearTimeout(debounceTimer.current);
  };

  // useEffect(() => {
  //   setShowData(pagination.data);

  //   if (
  //     deletionTrigger &&
  //     pagination.data.length === 0 &&
  //     pagination.currentPage > 1
  //   ) {
  //     pagination.setCurrentPage(pagination.currentPage - 1);
  //   }
  // }, [pagination.data]);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     fetchCountries();
  //     reloadCurrency();
  //   }, 1000);

  //   return () => clearTimeout(timer);
  // }, []);

  // useEffect(() => {
  //   reloadTable();
  // }, [searchText, filterStatus, filterDesignation]);

  // useEffect(() => {
  //   setSearchText("");
  // }, [filterColumn]);

  // useEffect(() => {
  //   function handleClickOutside(event) {
  //     if (yearRef.current && !yearRef.current.contains(event.target)) {
  //       setSelectYear(false);
  //     }
  //   }

  //   document.addEventListener("mousedown", handleClickOutside);

  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);

  const columns = [
    {
      name: (
        <input
          type="checkbox"
          checked={pagination.data
            .map((item) => item.id)
            .every((item) => selectedVendor.includes(item))} // Checkbox is checked if all items on the current page exist in selectedVendor
          onChange={(e) => {
            return e.target.checked
              ? // Add all items on the current page
                setSelectedVendor((prev) => [
                  ...prev,
                  ...pagination.data.map((item) => item.id),
                ])
              : // Remove currently visible items (on this page) from the selectedVendor list
                // Keeps only the selected items from other pages
                setSelectedVendor((prev) =>
                  prev.filter(
                    (vendorId) =>
                      !pagination.data
                        .map((item) => item.id)
                        .includes(vendorId),
                  ),
                );
          }}
        />
      ),
      selector: (row) => (
        <input
          type="checkbox"
          checked={selectedVendor.includes(row.id)} // Checkbox is checked if the id of vendor exist in selectedVendor
          onChange={(e) => {
            setSelectedVendor((prev) =>
              e.target.checked
                ? [...prev, row.id]
                : prev.filter((item) => item !== row.id),
            );
          }}
        />
      ),
      width: "8rem",
    },
    {
      name: "Company Name",
      selector: (row) => <NoTranslate> {row.company_name || "--"}</NoTranslate>,
      sortField: "company_name",
    },
    {
      name: "Nature",
      selector: (row) => (
        <NoTranslate>{row.company_nature || "--"}</NoTranslate>
      ),
      sortField: "company_nature",
    },
    {
      name: "Company Email",
      selector: (row) => <NoTranslate>{row.company_email || "--"}</NoTranslate>,
      sortField: "company_email",
    },
    {
      name: "Supplier Code",
      selector: (row) => <NoTranslate>{row.supplier_code || "--"}</NoTranslate>,
      sortField: "supplier_code",
    },
    {
      name: "City",
      selector: (row) => <NoTranslate>{row.company_city || "--"}</NoTranslate>,
      sortField: "company_city",
    },
    {
      name: "Country",
      selector: (row) => (
        <NoTranslate>{row.company_country || "--"}</NoTranslate>
      ),
      sortField: "company_country",
    },
    {
      name: "Designated",
      selector: (row) => <NoTranslate>{row.company_designation}</NoTranslate>,
      sortField: "company_designation",
    },
    {
      name: "Currency",
      selector: (row) => (
        <NoTranslate>{row.currency.currency_name}</NoTranslate>
      ),
      sortField: "currency_name",
    },
    {
      name: "Contact Person",
      selector: (row) => (
        <NoTranslate>
          {!row.fname || !row.lname ? "--" : `${row.fname} ${row.lname}`}
        </NoTranslate>
      ),
      sortField: "contact_person",
    },
    {
      name: "Contact",
      selector: (row) => <NoTranslate>{row.contact || "--"}</NoTranslate>,
      sortField: "contact",
    },
    {
      name: "Status",
      selector: (row) => <NoTranslate>{row.status}</NoTranslate>,
      sortField: "status",
      cell: (row) => (
        <div
          style={{
            padding: "5px, 10px",
            borderRadius: "5px",
            color: row.status
              ? row.status === "Active"
                ? "#3B9F3F"
                : "red"
              : "initial",
            textTransform: "uppercase",
            fontWeight: "bold",
          }}
        >
          <NoTranslate>{row.status}</NoTranslate>
        </div>
      ),
    },
    {
      name: "Action",
      selector: (row) => (
        <i
          className="fas fa-trash text-center"
          style={{ cursor: "pointer", color: "red", fontSize: "1.5rem" }}
          onClick={() => handleDeleteVendor(row.id)}
        ></i>
      ),
    },
  ];

  const uniqueSelectedVendor = [...new Set(selectedVendor)];

  const handleBulkDeleteVendor = () => {
    try {
      swal({
        icon: "warning",
        title: "Are you sure?",
        text: "Are you sure you want to delete?",
        buttons: ["Cancel", "OK"],
        dangerMode: true,
      })
        .then(async (confirm) => {
          if (confirm) {
            const res = await axios.put(
              `${BASE_URL}/vendors/vendorBulkSoftDelete`,
              {
                selectedVendor: [...new Set(selectedVendor)],
              },
            );

            if (res.status === 200) {
              swal({
                icon: "success",
                title: "Vendors Deleted",
                text: res.data.message,
              }).then(() => {
                setSelectedVendor([]);
                reloadTable();
                supplierCount();
                fetchMonthlySupplierCount();
              });
              return;
            }
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 409) {
            const wrapper = document.createElement("div");
            wrapper.innerHTML = `<span style="color: rgba(0, 0, 0, 0.65)">
            Company name <strong>${error.response.data.company_name}</strong> has an existing transaction. 
            Delete first the Purchase order in module <strong>Create Purchase</strong> with Transaction
                Number: <strong>${error.response.data.transaction_id}</strong>
            </span>`;
            swal({
              icon: "error",
              title: "Deletion Prohibited",
              content: wrapper,
            });
            return;
          }
          swal({
            title: "Something went wrong",
            text: "Please contact your support immediately",
            icon: "error",
            timer: 2000,
          });
        });
    } catch (error) {
      console.error(error);
    }
  };

  // const filteredItems = showData?.filter((item) => {
  //   if (!searchText) return true;

  //   const searchLower = searchText.toLowerCase();
  //   const contactPerson = `${item.fname} ${item.lname}`.toLowerCase(); // Concatenate and convert to lower case

  //   switch (filterColumn) {
  //     case "company_name":
  //       return item.company_name.toLowerCase().includes(searchLower);
  //     case "company_nature":
  //       return item.company_nature.toLowerCase().includes(searchLower);
  //     case "company_email":
  //       return item.company_email.toLowerCase().includes(searchLower);
  //     case "company_city":
  //       return item.company_city.toLowerCase().includes(searchLower);
  //     case "company_country":
  //       return item.company_country.toLowerCase().includes(searchLower);
  //     case "company_designation":
  //       return item.company_designation.toLowerCase().includes(searchLower);
  //     case "Contact":
  //       return item.contact.toString().toLowerCase().includes(searchLower);
  //     case "status":
  //       return item.status.toLowerCase().includes(searchLower);
  //     case "contact_person":
  //       return contactPerson.includes(searchLower); // Add contact person filter
  //     default:
  //       return (
  //         item.company_name.toLowerCase().includes(searchLower) ||
  //         item.company_nature.toLowerCase().includes(searchLower) ||
  //         item.company_email.toLowerCase().includes(searchLower) ||
  //         item.company_city.toLowerCase().includes(searchLower) ||
  //         item.company_country.toLowerCase().includes(searchLower) ||
  //         item.company_designation.toLowerCase().includes(searchLower) ||
  //         item.contact.toLowerCase().includes(searchLower) ||
  //         item.status.toLowerCase().includes(searchLower) ||
  //         contactPerson.includes(searchLower) // Add contact person to default filter
  //       );
  //   }
  // });

  // const applyFilter = () => {
  //   console.log(filterStatus);
  //   axios
  //     .get(BASE_URL + "/vendors/filterVendors", {
  //       params: {
  //         filterStatus,
  //         filterDesignation,
  //       },
  //     })
  //     .then((res) => {
  //       setShowData(res.data);
  //     });
  // };

  // const clearFilter = () => {
  //   setSearchText("");
  //   setFilterColumn("");
  //   setFilterDesignation("");
  //   setFilterStatus("");
  //   reloadTable();
  // };

  const currencyList = {
    PHP: "Philippine Peso (Philippines)",
    USD: "US Dollar (United States)",
    CNY: "Chinese Yuan (China)",
    HKD: "Hong Kong Dollar (Hong Kong)",
    EUR: "Euro (European Union)",
    JPY: "Japanese Yen (Japan)",
  };

  // Wrap CustomInput in useMemo and use local state to prevent react-datepicker
  // from overriding the user's backspaces on invalid intermediate dates.
  const CustomInput = useMemo(() => {
    const Input = React.forwardRef(
      (
        {
          value,
          onClick,
          onChange,
          onBlur,
          onFocus,
          onKeyDown,
          disabled,
          generateYears,
        },
        ref,
      ) => {
        // Local state allows free typing/backspacing without strict overrides
        const [localValue, setLocalValue] = useState(value || "");
        const [isFocused, setIsFocused] = useState(false);

        // Sync localValue with react-datepicker only when NOT focused.
        // This prevents react-datepicker from prematurely forcing a '2020' date
        // when typing an incomplete year like '202'.
        useEffect(() => {
          if (!isFocused) {
            setLocalValue(value || "");
          }
        }, [value, isFocused]);

        const handleChange = (e) => {
          const raw = e?.target?.value || "";

          // Remove any characters that aren't digits or slashes
          const cleaned = raw.replace(/[^\d/]/g, "");

          // Auto-format MM/dd/yyyy
          const next = cleaned
            .replace(/^(\d{2})(\d)/, "$1/$2")
            .replace(/^(\d{2}\/\d{2})(\d)/, "$1/$2");

          // Validate length up to MM/dd/yyyy format
          if (/^(\d{0,2}|\d{2}\/\d{0,2}|\d{2}\/\d{2}\/\d{0,4})$/.test(next)) {
            setLocalValue(next); // Update the visual input instantly

            // Pass the formatted value down to react-datepicker on EVERY keystroke
            // so validation and internal states are correctly updated.
            e.target.value = next;
            if (onChange) {
              onChange(e);
            }
          }
        };

        const handleFocus = (e) => {
          setIsFocused(true);
          if (onFocus) onFocus(e);
        };

        const handleBlur = (e) => {
          setIsFocused(false);
          // If the user leaves the field incomplete, trigger onChange again
          // to let react-datepicker finalize its state
          if (localValue.length > 0 && localValue.length < 10) {
            e.target.value = localValue;
            if (onChange) onChange(e);
          }
          if (onBlur) onBlur(e);
        };

        return (
          <input
            type="text"
            className="form-control p-2 w-100"
            style={{ cursor: "text" }}
            onClick={(e) => {
              if (onClick) onClick(e);

              let dateOfBirth = new Date().getFullYear();
              if (value) {
                const parsed = new Date(value);
                // Extract year safely if value is a valid date
                if (!isNaN(parsed.getTime())) {
                  dateOfBirth = parsed.getFullYear();
                }
              }

              if (generateYears && typeof generateYears === "function") {
                generateYears(dateOfBirth);
              }
            }}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
            onKeyDown={onKeyDown}
            value={localValue}
            ref={ref}
            placeholder="MM/dd/yyyy"
            disabled={disabled}
            required
          />
        );
      },
    );

    Input.displayName = "CustomInput";
    return Input;
  }, []);

  return (
    <div className="h-100 w-100 border bg-white custom-container">
      {isLoading ? (
        <div className="loading-container">
          <ThreeDot
            variant="brick-stack"
            color="#6290FE"
            size="large"
            text="Loading Data..."
            textColor=""
          />
        </div>
      ) : authrztn.includes("Vendors-View") ? (
        <>
          <div className="w-100 p-2 d-flex flex-row justify-content-between">
            <div className="d-flex flex-column title-custom">
              <span className="fs-3">Supplier</span>
            </div>

            <div className="d-flex flex-row">
              {/* Export PDF and CSV */}
              <div className="btn-group me-2">
                <button
                  type="button"
                  className="btn btn-success dropdown-toggle pt-2 px-3"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Export
                </button>
                <ul className="dropdown-menu">
                  <li
                    className="dropdown-item border-bottom"
                    style={{ cursor: "pointer" }}
                    onClick={() => exportToPdf()}
                  >
                    PDF
                  </li>
                  <li
                    className="dropdown-item"
                    style={{ cursor: "pointer" }}
                    onClick={() => exportToCsv()}
                  >
                    CSV
                  </li>
                </ul>
              </div>
              <VendorCsv data={exportData} csvLinkRef={csvLinkRef} />

              {authrztn.includes("Vendors-Add") &&
                (uniqueSelectedVendor.length > 0 ? (
                  <>
                    <button
                      className="btn btn-secondary title-button me-2"
                      onClick={() => setShowChangeStatusModal(true)}
                    >
                      <ArrowsClockwise className="fs-5" color="#f2f2f2" />{" "}
                      Change Status
                    </button>
                    <button
                      className="btn btn-danger title-button"
                      onClick={handleBulkDeleteVendor}
                    >
                      <i
                        className="fas fa-trash"
                        style={{
                          cursor: "pointer",
                          fontSize: "1rem",
                        }}
                      ></i>{" "}
                      Delete <span>({uniqueSelectedVendor.length})</span>
                    </button>
                  </>
                ) : (
                  <button
                    className="btn btn-primary d-flex align-items-center title-button"
                    onClick={handleShow}
                  >
                    <i className="bx bx-plus fs-5"></i> Add Supplier
                  </button>
                ))}
            </div>
          </div>
          <div className="row p-2 mx-auto d-flex align-items-center justify-content-center">
            <div className="col-sm-4 p-3 payable-card">
              <div className="w-100 border p-3 shadow-sm rounded h-100">
                <div className="d-flex flex-row align-items-center payable-icon">
                  <i className="bx bx-user-plus fs-3 h-100"></i>
                  <h3>Total Supplier</h3>
                </div>
                <div className="mt-2 d-flex flex-column payable-card-desc">
                  <h1 style={{ color: "var(--widget-number-color)" }}>
                    {totalSuppliers}
                  </h1>
                  <span className="text-secondary">
                    ACTIVE AND INACTIVE SUPPLIERS
                  </span>
                </div>
              </div>
            </div>
            <div className="col-sm-4 p-3 payable-card">
              <div className="w-100 border p-3 shadow-sm rounded h-100">
                <div className="d-flex flex-row align-items-center payable-icon">
                  <i className="bx bx-user-plus fs-3 h-100"></i>
                  <h3>New Supplier</h3>
                </div>
                <div className="mt-2 d-flex flex-column payable-card-desc">
                  <h1 style={{ color: "var(--widget-number-color)" }}>
                    {monthlySupplierCount}
                  </h1>
                  <span className="text-secondary">ADDED THIS MONTH</span>
                </div>
              </div>
            </div>
          </div>
          <div className="w-100 row mx-auto mt-4">
            <div className="col-sm mb-2">
              <span>Business Status</span>
              <select
                name="status"
                id="status"
                className="form-select"
                value={filterStatus}
                onChange={handleFilterStatusChange}
              >
                <option value="" selected disabled>
                  Select Status
                </option>
                <option value="All">All</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            <div className="col-sm mb-2">
              <span>Business Designation</span>
              <select
                name=""
                id=""
                className="form-select"
                value={filterDesignation}
                onChange={handleFilterDesignationChange}
              >
                <option value="" selected disabled>
                  Select Designation
                </option>
                <option value="All">All</option>
                <option value="Local">Local</option>
                <option value="Overseas">Overseas</option>
              </select>
            </div>

            <div className="col-sm mb-2">
              {/* <span>Currency</span>
          <select
            name=""
            id=""
            className="form-select"
            onChange={(e) => setCurrencyID(e.target.value)}
          >
            <option value="" selected disabled>
              Select Currency
            </option>
            {currency.map((item, index) => (
              <option key={index} value={item.id}>
                {item.currency_name}
              </option>
            ))}
          </select> */}
            </div>
            <div className="col-sm d-flex flex-row align-items-end mb-2 filter-btn-container">
              {/* <button className="btn" onClick={applyFilter}>
                Apply Filter
              </button>
              <button className="btn btn-secondary" onClick={clearFilter}>
                Clear Filter
              </button> */}
            </div>
            <div className="col-sm"></div>
          </div>
          <div className="w-100 mt-2 container-fluid">
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={searchText}
                onChange={handleSearchChange}
              />
              <button
                type="button"
                className="btn btn-outline-secondary dropdown-toggle-split"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa-solid fa-sliders"></i>
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "all" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("all")}
                  >
                    All
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "company_name" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("company_name")}
                  >
                    Company Name
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "company_nature" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("company_nature")}
                  >
                    Company Nature
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "company_email" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("company_email")}
                  >
                    Company Email
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "company_city" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("company_city")}
                  >
                    City
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "company_country" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("company_country")}
                  >
                    Country
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "fname" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("fname")}
                  >
                    Contact Person
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "contact" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("contact")}
                  >
                    Contact Number
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-3 container-fluid" style={{ maxWidth: "78.5vw" }}>
            <DataTable
              columns={sort.sortColumns(columns)}
              data={pagination.data}
              customStyles={customStyles}
              onRowClicked={(row) => {
                navigate(`../purchases/vendor-update/${row.id}`);
              }}
              className="dataTable data-table-cell-width"
              {...sort.sortProps}
            />
            <PaginationControls {...pagination} />
          </div>
        </>
      ) : (
        <div className="no-access">
          <img src={NoAccess} alt="NoAccess" className="no-access-img" />
          <h3>You don't have access to this function.</h3>
        </div>
      )}

      {/* PDF Modal Preview */}
      <Modal
        show={showPdfPreview}
        size="xl"
        onHide={() => setShowPdfPreview(false)}
      >
        <div className="position-relative">
          <PDFDownloadLink
            document={<VendorPdf data={exportData} />}
            fileName={`Supplier List.pdf`}
          >
            <Button
              variant="light"
              className="position-absolute btn btn-light border border-4 border-secondary mb-5 rounded-5"
              style={{ bottom: "7rem", left: "2rem" }}
            >
              <i className="fa-solid fa-download"></i>
            </Button>
          </PDFDownloadLink>
          <PDFViewer style={{ width: "100%", height: "100vh" }}>
            <VendorPdf data={exportData} />
          </PDFViewer>
        </div>
      </Modal>

      {/* add vendor */}
      <Modal show={showModal} onHide={handleClose} size="xl" backdrop="static">
        <Modal.Header className="border-0" closeButton>
          <Modal.Title>Create Supplier</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="w-100 container-fluid">
              <div className="w-100 d-flex align-items-center">
                <span>General Information</span>
                <hr className="flex-grow-1 mx-3" />
              </div>
              <div className="mt-2">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="tag-all-product"
                    value={tagAllProduct}
                    onChange={(e) => setTagAllProduct(e.target.checked)}
                  />
                  <label class="form-check-label" for="tag-all-product">
                    Tag All Product
                  </label>
                </div>
              </div>
              <div className="row w-100 mt-3">
                <div className="col-sm">
                  <Form.Group className="mb-3" controlId="companyName">
                    <Form.Label>Company Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={companyName}
                      placeholder="Enter Name"
                      onChange={(e) => setcompanyName(e.target.value)}
                      required
                      isInvalid={validated && !companyName.trim()}
                    />
                    <Form.Control.Feedback type="invalid">
                      Company name is required.
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
                <div className="col-sm">
                  <Form.Group className="mb-3" controlId="companyNature">
                    <Form.Label>Company Nature</Form.Label>
                    <Form.Control
                      type="text"
                      value={companyNature}
                      placeholder="Enter Nature"
                      onChange={(e) => setcompanyNature(e.target.value)}
                    />
                  </Form.Group>
                </div>
                <div className="col-sm">
                  <Form.Group className="mb-3" controlId="emailAddress">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type="text"
                      value={emailAddress}
                      placeholder="Enter Email"
                      onChange={(e) => setemailAddress(e.target.value)}
                    />
                  </Form.Group>
                </div>
              </div>
              <div className="row w-100 mt-3">
                <div className="col-12 col-md-4">
                  <Form.Group className="mb-3" controlId="companyAddress">
                    <Form.Label>Company Address</Form.Label>
                    <Form.Control
                      type="text"
                      value={companyAddress}
                      placeholder="Enter Address"
                      onChange={(e) => setCompanyAddress(e.target.value)}
                    />
                  </Form.Group>
                </div>
                <div className="col-12 col-md-4">
                  <Form.Group className="mb-3" controlId="companyAddress">
                    <Form.Label>Supplier Code</Form.Label>
                    <Form.Control
                      type="text"
                      value={supplierCode}
                      placeholder="Enter Code"
                      onChange={(e) => setSupplierCode(e.target.value)}
                    />
                  </Form.Group>
                </div>
                <div className="col-12 col-md-4">
                  <Form.Group className="mb-3" controlId="city">
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      type="text"
                      value={city}
                      placeholder="Enter City"
                      onChange={(e) => setCity(e.target.value)}
                    />
                  </Form.Group>
                </div>
              </div>
              <div className="row w-100 mt-3">
                <div className="col-sm mb-2">
                  <Form.Group className="mb-3" controlId="country">
                    <Form.Label>
                      Country {/*  <span className="text-danger">*</span> */}
                    </Form.Label>
                    <Select
                      inputId="country"
                      options={countryOptions}
                      value={
                        countryOptions.find(
                          (option) => option.value === country,
                        ) || null
                      }
                      onChange={(selectedOption) =>
                        setCountry(selectedOption ? selectedOption.value : "")
                      }
                      placeholder="Select Country"
                      styles={themeSelectStyles({})}
                      isClearable
                      isSearchable
                    />
                  </Form.Group>
                </div>
                <div className="col-sm">
                  <Form.Group className="mb-3" controlId="designation">
                    <Form.Label>
                      Designation <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      value={designation}
                      required
                      onChange={(e) => setDesignation(e.target.value)}
                    >
                      <option value="" disabled>
                        Select Designation
                      </option>
                      <option value="Local">Local</option>
                      <option value="Overseas">Overseas</option>
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className="col-sm">
                  <span>
                    Currency <span className="text-danger">*</span>
                  </span>
                  <select
                    name=""
                    id=""
                    required
                    className="form-select"
                    onChange={(e) => setCurrencyID(e.target.value)}
                  >
                    <option value="" selected disabled>
                      Select Currency
                    </option>
                    {currency.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.currency_name} -{" "}
                        {currencyList[item.currency_name]}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="row w-100 mt-3">
                <Form.Group className="mb-3" style={{ maxWidth: "360px" }}>
                  <Form.Label>Vat %</Form.Label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <Form.Check
                        checked={vatEnabled}
                        onChange={(e) => {
                          setVatEnabled(e.target.checked);
                          if (e.target.checked) {
                            setVatPercent(12);
                          } else {
                            setVatPercent(0);
                          }
                        }}
                      />
                    </span>
                    <Form.Control
                      type="number"
                      placeholder="Input Vat %"
                      min={0}
                      max={100}
                      value={vatPercent}
                      readOnly={!vatEnabled}
                      onChange={(e) => {
                        if (vatEnabled) setVatPercent(e.target.value);
                      }}
                      className={!vatEnabled ? "input-locked" : ""}
                    />
                  </div>
                </Form.Group>
              </div>

              <div className="w-100">
                <div className="w-100 mt-2 d-flex align-items-center">
                  <span>Contact Information</span>
                  <hr className="flex-grow-1 mx-3" />
                  {/* <Button variant="outline-primary" onClick={addContactPerson}>
                    <i className="fas fa-plus"></i>
                  </Button> */}
                </div>
                {/* {contactPersons.map((person, index) => ( */}
                <div className="border p-3 mb-3 position-relative">
                  {/* {index > 0 && (
                      <Button
                        variant="outline-danger"
                        size="sm"
                        className="position-absolute top-0 end-0 m-2"
                        onClick={() => removeContactPerson(index)}
                      >
                        <i className="fas fa-times"></i>
                      </Button>
                    )} */}
                  <div className="row w-100 mt-3">
                    <div className="col-sm">
                      <Form.Group className="mb-3" controlId={`firstName`}>
                        <Form.Label>
                          First Name
                          {/* <span className="text-danger">*</span> */}
                        </Form.Label>
                        <Form.Control
                          type="text"
                          // required
                          placeholder="Enter First Name"
                          value={fname}
                          onChange={(e) => {
                            // const newContactPersons = [...contactPersons];
                            // newContactPersons[index].fname = e.target.value;
                            // setContactPersons(newContactPersons);
                            setFname(e.target.value);
                          }}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-sm">
                      <Form.Group className="mb-3" controlId={`lastName`}>
                        <Form.Label>
                          Last Name
                          {/* <span className="text-danger">*</span> */}
                        </Form.Label>
                        <Form.Control
                          type="text"
                          // required
                          value={lname}
                          placeholder="Enter Last Name"
                          onChange={(e) => {
                            // const newContactPersons = [...contactPersons];
                            // newContactPersons[index].lname = e.target.value;
                            // setContactPersons(newContactPersons);
                            setLname(e.target.value);
                          }}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-sm">
                      <Form.Group className="mb-3" controlId={`middleName`}>
                        <Form.Label>Middle Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Middle Name"
                          value={mname}
                          onChange={(e) => {
                            // const newContactPersons = [...contactPersons];
                            // newContactPersons[index].mname = e.target.value;
                            // setContactPersons(newContactPersons);
                            setMname(e.target.value);
                          }}
                        />
                      </Form.Group>
                    </div>
                  </div>
                  <div className="row w-100 mt-3">
                    <div className="col-sm">
                      <Form.Group className="mb-3" controlId={`civilStatus`}>
                        <Form.Label>Civil Status</Form.Label>
                        <Form.Select
                          value={civilStatus}
                          onChange={(e) => {
                            setCivilStatus(e.target.value);
                          }}
                        >
                          <option value="" disabled>
                            Select Civil Status
                          </option>
                          <option value="Single">Single</option>
                          <option value="Married">Married</option>
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-sm">
                      <Form.Group className="mb-3" controlId={`dob`}>
                        <Form.Label>Date of Birth</Form.Label>
                        {/* <Form.Control
                          type="date"
                          value={dob}
                          onChange={(e) => {
                            // const newContactPersons = [...contactPersons];
                            // newContactPersons[index].dob = e.target.value;
                            // setContactPersons(newContactPersons);
                            setDob(e.target.value);
                          }}
                        /> */}
                        <CustomDatePicker
                          label={"Birthday"}
                          selected={dob ? new Date(dob) : null}
                          handleDateChange={handleDateChange}
                          CustomInput={CustomInput}
                          validated={validated}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-sm">
                      <Form.Group className="mb-3" controlId={`gender`}>
                        <Form.Label>Choose Gender</Form.Label>
                        <div className="row">
                          <div className="col-sm mb-1">
                            <Form.Check
                              type="radio"
                              name={`gender`}
                              id={`male`}
                              label="Male"
                              value="Male"
                              checked={gender === "Male"}
                              onChange={(e) => {
                                // const newContactPersons = [...contactPersons];
                                // newContactPersons[index].gender =
                                //   e.target.value;
                                // setContactPersons(newContactPersons);
                                setGender("Male");
                              }}
                            />
                          </div>
                          <div className="col-sm mb-1">
                            <Form.Check
                              type="radio"
                              name={`gender`}
                              id={`female`}
                              label="Female"
                              value="Female"
                              checked={gender === "Female"}
                              onChange={(e) => {
                                // const newContactPersons = [...contactPersons];
                                // newContactPersons[index].gender =
                                //   e.target.value;
                                // setContactPersons(newContactPersons);
                                setGender("Female");
                              }}
                            />
                          </div>
                        </div>
                      </Form.Group>
                    </div>
                  </div>
                  <div className="row w-100 mt-3">
                    <div className="col-sm">
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Cellphone No.
                          {/* <span className="text-danger">*</span> */}
                        </Form.Label>
                        <div className="input-group">
                          <span className="input-group-text">+63</span>
                          <Form.Control
                            type="text"
                            // required
                            placeholder="Enter Cellphone Number"
                            value={contactNo}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) => setContactNo(e.target.value)}
                            maxLength={11}
                          />
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-sm">
                      <Form.Group className="mb-3">
                        <Form.Label>Additional Contact No.</Form.Label>
                        <div className="input-group">
                          <span className="input-group-text">+63</span>
                          <Form.Control
                            type="text"
                            placeholder="Enter Contact Number"
                            value={contactNo2}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) => setContactNo2(e.target.value)}
                            maxLength={11}
                          />
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-sm">
                      <Form.Group className="mb-3">
                        <Form.Label>Tin ID</Form.Label>
                        <Form.Control
                          type="text"
                          value={tin}
                          placeholder="Enter TIN Number"
                          maxLength={15}
                          onChange={(e) => {
                            // const newContactPersons = [...contactPersons];
                            // newContactPersons[index].tin = e.target.value;
                            // setContactPersons(newContactPersons);
                            setTin(e.target.value);
                          }}
                        />
                      </Form.Group>
                    </div>
                  </div>
                </div>
                {/* ))} */}
              </div>
            </div>
            <Modal.Footer className="border-0">
              <Button variant="secondary" type="button" onClick={handleClose}>
                Close
              </Button>
              <Button variant="primary" type="submit">
                Submit
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Change Status Modal */}
      <Modal
        show={showChangeStatusModal}
        onHide={() => setShowChangeStatusModal(false)}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label htmlFor="change-status">Status</label>
          <select
            name="change-status"
            id="change-status"
            value={changeToStatus}
            onChange={(e) => setChangeToStatus(e.target.value)}
            className="form-select"
          >
            <option value="" selected disabled>
              Select Status
            </option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={handleChangeStatus}>
            Save
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => setShowChangeStatusModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      {/* update modal */}
      {/* <Modal
        show={showUpdateModal}
        onHide={handleClose}
        size="xl"
        backdrop="static"
      >
        <Modal.Header className="border-0">
          <Modal.Title>Update Vendor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            noValidate
            validated={validated}
            onSubmit={handleUpdate}
            className="vendor-container scrollable-contents"
          >
            <div className="w-100 container-fluid">
              <div className="w-100 d-flex align-items-center">
                <span>General Information</span>
                <hr className="flex-grow-1 mx-3" />
              </div>
              <div className="row w-100 mt-3">
                <div className="col-sm">
                  <Form.Group className="mb-3" controlId="companyName">
                    <Form.Label>Company Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={companyName}
                      required
                      placeholder="Enter Name"
                      onChange={(e) => setcompanyName(e.target.value)}
                    />
                  </Form.Group>
                </div>
                <div className="col-sm">
                  <Form.Group className="mb-3" controlId="companyNature">
                    <Form.Label>Company Nature</Form.Label>
                    <Form.Control
                      type="text"
                      required
                      value={companyNature}
                      placeholder="Enter Nature"
                      onChange={(e) => setcompanyNature(e.target.value)}
                    />
                  </Form.Group>
                </div>
                <div className="col-sm">
                  <Form.Group className="mb-3" controlId="emailAddress">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type="text"
                      required
                      value={emailAddress}
                      placeholder="Enter Email"
                      onChange={(e) => setemailAddress(e.target.value)}
                    />
                  </Form.Group>
                </div>
              </div>
              <div className="row w-100 mt-3">
                <div className="col-12 col-md-8">
                  <Form.Group className="mb-3" controlId="companyAddress">
                    <Form.Label>Company Address</Form.Label>
                    <Form.Control
                      type="text"
                      required
                      value={companyAddress}
                      placeholder="Enter Address"
                      onChange={(e) => setCompanyAddress(e.target.value)}
                    />
                  </Form.Group>
                </div>
                <div className="col-12 col-md-4">
                  <Form.Group className="mb-3" controlId="city">
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      type="text"
                      required
                      value={city}
                      placeholder="Enter City"
                      onChange={(e) => setCity(e.target.value)}
                    />
                  </Form.Group>
                </div>
              </div>
              <div className="row w-100 mt-3">
                <div className="col-sm mb-2">
                  <Form.Group controlId="country">
                    <Form.Label>Country</Form.Label>
                    <Select
                      options={countryOptions}
                      value={countryOptions.find(
                        (option) => option.value === country
                      )}
                      onChange={(selectedOption) =>
                        setCountry(selectedOption ? selectedOption.value : "")
                      }
                      placeholder="Select Country"
                      styles={themeSelectStyles({})}
                      isClearable
                      isSearchable
                    />
                  </Form.Group>
                </div>
                <div className="col-sm">
                  <Form.Group className="mb-3" controlId="designation">
                    <Form.Label>Designation</Form.Label>
                    <Form.Select
                      required
                      value={designation}
                      onChange={(e) => setDesignation(e.target.value)}
                    >
                      <option value="" selected disabled>
                        Select Designation
                      </option>
                      <option value="Local">Local</option>
                      <option value="Overseas">Overseas</option>
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className="col-sm"></div>
              </div>

              <div className="w-100">
                <div className="w-100 mt-2 d-flex align-items-center">
                  <span>Contact Information</span>
                  <hr className="flex-grow-1 mx-3" />
                </div>
                <div className="row w-100 mt-3">
                  <div className="col-sm">
                    <Form.Group className="mb-3" controlId="firstName">
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type="text"
                        required
                        placeholder="Enter First Name"
                        value={fname}
                        onChange={(e) => setFname(e.target.value)}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-sm">
                    <Form.Group className="mb-3" controlId="lastName">
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type="text"
                        required
                        value={lname}
                        placeholder="Enter Last Name"
                        onChange={(e) => setLname(e.target.value)}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-sm">
                    <Form.Group className="mb-3" controlId="middleName">
                      <Form.Label>Middle Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Middle Name"
                        value={mname}
                        onChange={(e) => setMname(e.target.value)}
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="row w-100 mt-3">
                  <div className="col-sm">
                    <Form.Group className="mb-3" controlId="civilStatus">
                      <Form.Label>Civil Status</Form.Label>
                      <Form.Select
                        required
                        value={civilStatus}
                        onChange={(e) => setCivilStatus(e.target.value)}
                      >
                        <option value="" selected disabled>
                          Select Civil Status
                        </option>
                        <option value="Single">Single</option>
                        <option value="Married">Married</option>
                      </Form.Select>
                    </Form.Group>
                  </div>
                  <div className="col-sm">
                    <Form.Group className="mb-3" controlId="lastName">
                      <Form.Label>Date of Birth</Form.Label>
                      <Form.Control
                        type="date"
                        required
                        value={dob}
                        onChange={(e) => setDob(e.target.value)}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-sm">
                    <Form.Group className="mb-3" controlId="gender">
                      <Form.Label>Choose Gender</Form.Label>
                      <div className="row">
                        <div className="col-sm mb-1">
                          <Form.Check
                            type="radio"
                            name="gender"
                            id="male"
                            label="Male"
                            value="Male"
                            checked={gender === "Male"}
                            onChange={(e) => setGender(e.target.value)}
                          />
                        </div>
                        <div className="col-sm mb-1">
                          <Form.Check
                            type="radio"
                            name="gender"
                            id="female"
                            label="Female"
                            value="Female"
                            checked={gender === "Female"}
                            onChange={(e) => setGender(e.target.value)}
                          />
                        </div>
                      </div>
                    </Form.Group>
                  </div>
                </div>
                <div className="row w-100 mt-3">
                  <div className="col-sm">
                    <Form.Group className="mb-3" controlId="mobileNumber">
                      <Form.Label>Contact No.</Form.Label>
                      <Form.Control
                        type="text"
                        required
                        placeholder="Enter Contact Number"
                        value={contactNo}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*$/.test(value)) {
                            setContactNo(value);
                          }
                        }}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-sm">
                    <Form.Group className="mb-3" controlId="tinNumber">
                      <Form.Label>TIN</Form.Label>
                      <Form.Control
                        type="text"
                        value={tin}
                        placeholder="Enter TIN Number"
                        onChange={(e) => setTin(e.target.value)}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-sm">
                    <Form.Group className="mb-3" controlId="jobPosition">
                      <Form.Label>Job Position</Form.Label>
                      <Form.Control
                        type="text"
                        required
                        placeholder="Enter Position"
                        value={position}
                        onChange={(e) => setPosition(e.target.value)}
                      />
                    </Form.Group>
                  </div>
                </div>
              </div>
            </div>
            <Modal.Footer className="border-0">
              <Button
                variant="outline-secondary"
                type="button"
                onClick={handleClose}
              >
                Close
              </Button>
              <Button variant="primary" type="submit">
                Submit
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal> */}
    </div>
  );
};

export default Vendors;
